import {LOCALE} from './locale';

/** "Dismissed by Arash on 1 Nov 2026" for a dismissed risk; the parts that are not known are left out. */
export function dismissedText(d: {dismissedBy: string | null; dismissedAt: string | null}): string {
    const when = d.dismissedAt
        ? new Date(d.dismissedAt).toLocaleDateString(LOCALE, {day: 'numeric', month: 'short', year: 'numeric'})
        : null;
    return ['Dismissed', d.dismissedBy && `by ${d.dismissedBy}`, when && `on ${when}`].filter(Boolean).join(' ');
}
